import { func } from "prop-types";
import { useState } from "react";
import { useRouteMatch } from "react-router-dom";

import API from "Boards/API";
import { useBoards } from "Boards/BoardContext";
import { BOARD_TYPES } from "Boards/const";

useRefreshBoardData.propTypes = {
  onSuccess: func,
  onError: func,
};

export function useRefreshBoardData({
  onSuccess = () => {},
  onError = () => {},
}) {
  const [isLoading, setIsLoading] = useState(false);

  const match = useRouteMatch();
  const groupURL = match.params.groupURL;
  const boardURL = match.params.boardURL;

  const [{ boardID, extendedFields, boardType }, dispatch] = useBoards();
  const isReportBoard = boardType === BOARD_TYPES.REPORT;

  const refreshBoardData = () => {
    setIsLoading(true);

    let getBoardCall = isReportBoard
      ? API.getReportBoard({ boardID, bypassSavedBoardFilter: true })
      : API.getGroupBoard({
          groupURL,
          boardURL,
          bypassSavedBoardFilter: true,
        });

    getBoardCall
      .post()
      .then((boardData) => {
        if (boardData?.boardInfo?.url !== boardURL) return;

        dispatch({ type: "setBoardData", payload: boardData });
        onSuccess();
      })
      .catch(() => {
        console.log("error getting board data");
        setIsLoading(false);
        onError();
      });
  };

  return { refreshBoardData, isLoading };
}
